

import { Component, OnInit } from '@angular/core';
import { LogApi, Log, SortParameters, LogGridInfo } from 'src/app/core/api.gen';
import { DialogService } from 'src/app/core/dialog.service';

@Component({
  selector: 'eos-log-grid',
  templateUrl: './log-grid.component.html'
})
export class LogGridComponent implements OnInit {

  // Data model

  dataWithFilter: LogGridInfo = new LogGridInfo();
  showModal: boolean;
  currentPage = 1;
  page: number;
  changeCount: number[] = [10, 15, 25];
  totalPages: number;

  constructor(
    private logAPI: LogApi,
    private dialog: DialogService,
  ) {
    this.dataWithFilter.sortParameters = new SortParameters();
    this.dataWithFilter.logList = [];
  }


  ngOnInit() {
    this.dataWithFilter.sortParameters.page = 1;
    this.dataWithFilter.sortParameters.itemsPerPage = 10;
    this.dataWithFilter.sortParameters.totalRecords = 0;
    this.getLogDetailsList();
  }

  viewLogDetails(id: number) {
    this.dialog.showLogDetails(id);  // to display details as modal pop up
  }


  pageChanged(event: any): void {
    this.dataWithFilter.sortParameters.itemsPerPage = event.itemsPerPage;
    this.dataWithFilter.sortParameters.page = event.page;
    this.logAPI.getLogWithFilters(this.dataWithFilter.sortParameters).subscribe(log => {
      this.dataWithFilter = log;
    });

  }

  getLogDetailsList() {
    this.logAPI.getLogWithFilters(this.dataWithFilter.sortParameters).subscribe(log => {
      this.dataWithFilter = log;
    });
  }

  onSelectChanges() {
    this.getLogDetailsList();
  }


}




